<template>
  <div>
    <SelectorPanel
      type="assets"
      text="Assets"
      :disabled="disabled"
      :force-close="forceClose"
    >
      <SelectorPanelHeader
        type="assets"
        title="Assets"
        class="pb-2"
        dense
        @click-close="handleClickClose"
      ></SelectorPanelHeader>

      <AssetsContent></AssetsContent>
    </SelectorPanel>
  </div>
</template>
<script>
export default {
  name: "AssetsSelector",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel.vue"),
    SelectorPanelHeader: () =>
      import("@/components/common/SelectorPanelHeader.vue"),
    AssetsContent: () =>
      import("@/components/assetManagement/AssetsContent.vue"),
  },
  data: () => ({
    forceClose: null,
  }),
  methods: {
    handleClickClose() {
      this.forceClose = new Date().toISOString();
    },
  },
};
</script>

<style></style>

<style scoped></style>
